import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../configure-store.js'
import type { Unsubscribe } from 'redux'

export type TunaThunkDispatch = AppDispatch

export type ReduxSubscribe = (cb: () => void) => Unsubscribe

export const useThunkDispatch = () => useDispatch<TunaThunkDispatch>()
